// extracted by mini-css-extract-plugin
export default {"page":"Notification_page__dgbUU"};